import {useAuthStore} from '@/features/auth/store/store'
import {Fm22WindowProject, getFm22Window} from '@/features/projects/utils'

/**
 * FM22 edit/print window for the logged-in user (OPSSTD-4462).
 * Denies access while the project is unavailable: callers render loaders and errors before this matters.
 */
export const useFm22Window = (project: Fm22WindowProject | undefined | null) => {
    const roleName = useAuthStore(state => state.user?.roleName)

    if (!project) {
        return {canEditFm22: false, editDeadline: null}
    }

    return getFm22Window({project, roleName})
}
